// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iVlf6","option":"styles_option__1l5rL","active":"styles_active__2e1ls"};